import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {IEcommerceAnalyticsEntityState} from "../reducers/ecommerce-analytics.reducer";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getEcommerceAnalyticsState = (websiteId: number) =>
  createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.ecommerceAnalytics.entities[websiteId]);

export const getEcommerceAnalytics = (websiteId: number) => createSelector(getEcommerceAnalyticsState(websiteId),
  (state: IEcommerceAnalyticsEntityState) => {
    return state.data
  }
);

export const getEcommerceAnalyticsBefore = (websiteId: number) => createSelector(getEcommerceAnalyticsState(websiteId),
  (state: IEcommerceAnalyticsEntityState) => {
    return state?.data?.current;
  }
);

export const getEcommerceAnalyticsNow = (websiteId: number) => createSelector(getEcommerceAnalyticsState(websiteId),
  (state: IEcommerceAnalyticsEntityState) => {
      return state?.data?.previous;
  }
);

export const getEcommerceAnalyticsTotal = (websiteId: number, nowData: boolean) => createSelector(getEcommerceAnalyticsState(websiteId),
  (state: IEcommerceAnalyticsEntityState) => {
    if (!state?.data) return {};
      const setData = nowData ? state?.data?.current["performance-indicators"] : state?.data?.previous["performance-indicators"];
      return {
        totalSales: setData.find(value => value?.stat === "revenue/total_sales"),
        netRevenue: setData.find(value => value?.stat === "revenue/net_revenue"),
        ordersCount: setData.find(value => value?.stat === "orders/orders_count"),
        itemsSold: setData.find(value => value?.stat === "products/items_sold"),
        totalTax: setData.find(value => value?.stat === "taxes/total_tax"),
        itemsSoldNumber: setData.find(value => value?.stat === "variations/items_sold")
    };
  }
);

export const getEcommerceAnalyticsNetSales = (websiteId: number, nowData: boolean) => createSelector(getEcommerceAnalyticsState(websiteId),
    (state: IEcommerceAnalyticsEntityState) => {
        if (!state?.data) return {};
        const setData = nowData ? state?.data?.current["revenue/stats"] : state?.data?.previous["revenue/stats"];
        return setData?.intervals;
    }
);

export const getEcommerceAnalyticsReportsOrder = (websiteId: number, nowData: boolean) => createSelector(getEcommerceAnalyticsState(websiteId),
    (state: IEcommerceAnalyticsEntityState) => {
        if (!state?.data) return {};
        const setData = nowData ? state?.data?.current["orders/stats"] : state?.data?.previous["orders/stats"];
        return setData?.intervals;
    }
);

export const getEcommerceAnalyticsLoading = (websiteId: number) => createSelector(getEcommerceAnalyticsState(websiteId),
  (state: IEcommerceAnalyticsEntityState) => state && state.loading
);

export const getEcommerceAnalyticsLoaded = (websiteId: number) => createSelector(getEcommerceAnalyticsState(websiteId),
  (state: IEcommerceAnalyticsEntityState) => {
      return state && state.loaded
  }
);
